import { createMobxContext } from "./Provider";
export const createStore = (initialData) => {
    const store = createMobxContext(initialData);
    return {
        useStore: store.getUseStore(),
        Provider: store.MobxProvider
    };
};
